<template>
    <div
        class="w-5 h-5 text-xs font-semibold flex items-center justify-center"
        :class="square ? 'rounded' : 'rounded-full'"
        style="font-size: 10px;"
        :style="`background-color: ${colour.value}; color: ${colour.dark ? 'white' : 'black'};`"
        :title="spec.title"
        v-text="initials"
    ></div>
</template>

<script>
import { take } from 'lodash'
import { estimateStore } from '@stores'

const colours = [
    // Vivid colours.
    { value: '#EC4899', dark: true },
    { value: '#F59E0B', dark: true },
    { value: '#0EA5E9', dark: true },
    { value: '#34D399', dark: true },
    { value: '#A855F7', dark: true },
    { value: '#E11D48', dark: true },
    { value: '#84CC16', dark: true },

    // Dark colours.
    { value: '#111827', dark: true },
    { value: '#0E7490', dark: true },
    { value: '#0F766E', dark: true },
    { value: '#86198F', dark: true },

    // Light colours.
    { value: '#CBD5E1', dark: false },
    { value: '#FDE68A', dark: false },
    { value: '#99F6E4', dark: false },
    { value: '#E9D5FF', dark: false },
    { value: '#FCA5A5', dark: false },
]

export default {
    props: {
        spec: Object,
        square: Boolean,
    },
    computed: {
        index () {
            return estimateStore.state.localSpecs.findIndex(spec => spec.id === this.spec.id)
        },
        colour () {
            return colours[this.index % colours.length]
                || ({ value: 'black', dark: true })
        },
        initials () {
            const title = (this.spec.title || '').replace(/[^0-9a-z\s]/gi, '')
            const initials = title.split(' ').filter(word => !! word).map(word => word[0])
            return take(initials, 2).join('').toUpperCase()
        },
    },
}
</script>
